var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3043 11.8324C23.3043 5.58758 18.0891 0.527954 11.6522 0.527954C5.21529 0.527954 0 5.58758 0 11.8324C0 17.4745 4.26103 22.1513 9.83152 23V15.1001H6.87149V11.8324H9.83152V9.34174C9.83152 6.5088 11.57 4.94396 14.2326 4.94396C15.5077 4.94396 16.8412 5.16458 16.8412 5.16458V7.9451H15.3715C13.9243 7.9451 13.4728 8.81663 13.4728 9.7105V11.8324H16.7044L16.1876 15.1001H13.4728V23C19.0433 22.1513 23.3043 17.4745 23.3043 11.8324Z",
    fill: "#545776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineFacebook);
export default __webpack_public_path__ + "static/media/outline-facebook.3f7ed787f9d2ee1e6851d61b608b9333.svg";
export { ForwardRef as ReactComponent };